import { useContext, useState } from 'react';

import { isFacebookImportSupported } from '@bingads-webui-campaign-react/smart-page-facebook-import-dialog';
import { SiteConfigContext } from '@bingads-webui-campaign-react/smart-page-context';
import { getImageMetaById } from '@bingads-webui-campaign-react/smart-component-util';

import { ImageOptionsKey } from './consts';

export const useExistingUploadedImage = ({
  imageId,
  externalSrc,
  fileName,
}) => {
  const { siteConfig } = useContext(SiteConfigContext);
  const enableFacebookImport = !!isFacebookImportSupported(siteConfig);
  let defaultSelectedImageOption = ImageOptionsKey.DEFAULT;
  let image = null;

  if (imageId) {
    image = getImageMetaById(siteConfig, imageId);

    if (externalSrc) {
      defaultSelectedImageOption = ImageOptionsKey.DEFAULT;
    } else if (fileName || !enableFacebookImport) {
      defaultSelectedImageOption = ImageOptionsKey.UPLOAD;
    } else {
      defaultSelectedImageOption = ImageOptionsKey.FACEBOOKIMPORT;
    }
  }

  const [
    selectedImageOption,
    setSelectedImageOption,
  ] = useState(defaultSelectedImageOption);
  const [facebookImageInfo, setFacebookImageInfo]
    = useState(defaultSelectedImageOption === ImageOptionsKey.FACEBOOKIMPORT
      ? image : null);
  const [stockImageInfo, setStockImageInfo]
    = useState(defaultSelectedImageOption === ImageOptionsKey.DEFAULT
      ? { image, externalSrc } : null);
  const [uploadedFileInfo, setUploadedFileInfo]
    = useState(defaultSelectedImageOption === ImageOptionsKey.UPLOAD
      ? {
        file: fileName && { name: fileName },
        image,
      } : null);

  return {
    selectedImageOption,
    setSelectedImageOption,

    enableFacebookImport,
    facebookImageInfo,
    setFacebookImageInfo,

    uploadedFileInfo,
    setUploadedFileInfo,

    stockImageInfo,
    setStockImageInfo,
  };
};
